function GetConsoleTab() {
  const splitUrl = window.location.href.split('/')
  return splitUrl[splitUrl.length - 1];
}

export { GetConsoleTab }